import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from './../../utils/styles'
import { renderActions } from './../../utils/actions'
import styles from './ResourceList.scss'

export default function Item({ children, actions, className, media, onClick, subdued }) {
  const handleClick = event => {
    event.preventDefault()
    onClick(event)
  }

  const ItemClass = classNames(styles.Item, onClick && styles.HasClick, subdued && styles.Subdued, className)

  return (
    <div className={ItemClass}>
      <div className={classNames(styles.ItemContent)}>{children}</div>
      {onClick && <button onClick={handleClick} className={styles.ItemLink} />}
      {media && <div className={styles.ItemMedia}>{media}</div>}
      {actions && <div className={classNames(styles.ItemActions)}>{renderActions(actions, {}, '', 'trailing')}</div>}
    </div>
  )
}

Item.propTypes = {
  media: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
  item: PropTypes.object,
  subdued: PropTypes.bool,
  actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.bool]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
}



// WEBPACK FOOTER //
// ./src/components/ResourceList/Item.js